import empty_state_sales from './empty_state_sales.png';
import upgrade_intent from './upgrade_intent.png';
import upgrade_scoops from './upgrade_scoops.png';
import upgrade_tech from './upgrade_tech.png';
import upgrade_websight from './upgrade_websights.png';
import congrats from './congrats.png';
import not_authorized from './401.png';
import error_page from './error_page_sales.png';
import highlights_builder_sales from './highlights_builder_sales.png';

const illustrationConfig = {
  emptyState: {
    sales: empty_state_sales,
    marketing: empty_state_sales,
  },
  upgrade: {
    intent: { sales: upgrade_intent, marketing: upgrade_intent },
    scoops: { sales: upgrade_scoops, marketing: upgrade_scoops },
    technologies: { sales: upgrade_tech, marketing: upgrade_tech },
    websight: { sales: upgrade_websight, marketing: upgrade_websight },
  },
  congrats: { sales: congrats, marketing: congrats },
  unauthorized: { sales: not_authorized, marketing: not_authorized },
  noAccess: {
    sales: empty_state_sales,
    marketing: empty_state_sales,
  },
  errorPage: { sales: error_page, marketing: error_page },
  highlights: {
    builder: {
      sales: highlights_builder_sales,
      marketing: highlights_builder_sales,
    },
  },
};

export default illustrationConfig;
